import { Injectable } from '@angular/core';
import { currentTenantUsesWsFed } from './tenant.util';

/**
 * Thin injectable wrapper around the tenant helpers. Consumers such as the auth
 * interceptor depend on this service (which can be mocked in unit tests) instead
 * of importing the module-level function directly — ESM named imports are not
 * spy-able under the esbuild-based test builder.
 */
@Injectable({ providedIn: 'root' })
export class TenantService {
  usesWsFed(): boolean {
    return currentTenantUsesWsFed();
  }
}
